import { Box, IconButton } from '@mui/material';
import React from 'react';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';

const iconMap = {
    facebook: FacebookIcon,
    instagram: InstagramIcon,
    twitter: XIcon,
    linkedin: LinkedInIcon,
    youtube: YouTubeIcon,
};

const Social = ({ data }) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {Object.entries(data || {}).map(([key, url]) => {
                if (!url) return null;
                const Icon = iconMap[key.toLowerCase()];
                if (!Icon) return null;
                return (
                    <IconButton
                        key={key}
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                            color: '#C59850',
                            border: '1px solid rgba(255,255,255,0.2)',
                            borderRadius: '50%',
                            width: 36,
                            height: 36,
                            '&:hover': { bgcolor: '#C59850', color: '#FFFFFF', border: '1px solid #C59850' },
                        }}
                        size="small"
                    >
                        <Icon sx={{ fontSize: 18 }} />
                    </IconButton>
                );
            })}
        </Box>
    );
};

export default Social;
